import React from 'react';
import {classes, st} from '../../../common/components/Layout/Layout.st.css';
import {WrapWithDiv} from '../../../common/components/Layout/WrapWithDiv';
import {MainLoader} from '../../../common/components/Layout/MainLoader/MainLoader';
import {AsideLoader} from '../../../common/components/Layout/AsideLoader/AsideLoader';
import {HeaderLoader} from '../../../common/components/Layout/HeaderLoader/HeaderLoader';
import {A11yIds, SPECS} from '../../../common/constants';
import {useExperiments, useEnvironment} from '@wix/yoshi-flow-editor';
import {Spinner} from '@wix/wix-ui-tpa/cssVars';

export enum LoadingLayoutDataHooks {
  root = 'LoadingLayoutDataHooks.root',
  mainSection = 'LoadingLayoutDataHooks.mainSection',
  oneColumnViewSummary = 'LoadingLayoutDataHooks.oneColumnViewSummary',
  twoColumnViewSummary = 'LoadingLayoutDataHooks.twoColumnViewSummary',
  verticalDivider = 'LoadingLayoutDataHooks.verticalDivider',
  spinner = 'LoadingLayoutDataHooks.spinner',
}

export interface LoadingLayoutProps {
  isOneColumnView?: boolean;
}

export const LoadingLayout = ({isOneColumnView}: LoadingLayoutProps) => {
  const {experiments} = useExperiments();
  const {isEditor} = useEnvironment();
  const ecomCheckoutBrandStyling = experiments.enabled(SPECS.ecomCheckoutBrandStyling);
  /* istanbul ignore next */
  const mainClass = ecomCheckoutBrandStyling ? classes.main : classes.deprecatedMain;
  /* istanbul ignore next */
  const asideClass = ecomCheckoutBrandStyling ? classes.aside : classes.deprecatedAside;
  /* istanbul ignore next */
  const loadingRootClass = ecomCheckoutBrandStyling ? classes.loadingRoot : undefined;

  if (isEditor) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner data-hook={LoadingLayoutDataHooks.spinner} isCentered={true} />
      </div>
    );
  }

  return (
    <div data-hook={LoadingLayoutDataHooks.root} className={st(classes.root, loadingRootClass)}>
      <HeaderLoader />
      <WrapWithDiv className={st(classes.mainContainer, classes.loadingMainContainer)}>
        <div className={classes.container}>
          {isOneColumnView && (
            <WrapWithDiv className={st(classes.summaryContainer, classes.loadingSummaryContainer)}>
              <aside
                data-hook={LoadingLayoutDataHooks.oneColumnViewSummary}
                className={st(asideClass, classes.loadingAside)}
              />
            </WrapWithDiv>
          )}
          <WrapWithDiv className={classes.formContainer}>
            <section className={mainClass} data-hook={LoadingLayoutDataHooks.mainSection}>
              <MainLoader />
            </section>
          </WrapWithDiv>
          {!isOneColumnView && <div data-hook={LoadingLayoutDataHooks.verticalDivider} className={classes.divider} />}
          <WrapWithDiv className={st(classes.summaryContainer, classes.loadingSummaryContainer)}>
            <section
              aria-labelledby={A11yIds.SummarySection}
              data-hook={LoadingLayoutDataHooks.twoColumnViewSummary}
              className={st(asideClass, classes.loadingAside)}>
              <AsideLoader />
            </section>
          </WrapWithDiv>
        </div>
      </WrapWithDiv>
    </div>
  );
};
